import { Pipe, PipeTransform } from '@angular/core';
/**
 * Adds a space after a specified character in a given string
 * Useful for formatting names (e.g 'LastName, FirstName')
 */
@Pipe({
    name: 'addTrailingWhitespace',
    pure: true
})
export class AddTrailingWhitespace implements PipeTransform {

    //It is expected that character will be a string of length 1.
    //Typescript does not support a char type or I would have used that instead of string.
    transform(value: string, character: string) {
        if (!value) {
            return;
        }

        var results = value.split(character);
        results = results.map(x => x.trim()).slice();
        var result = results.join(`${character} `);
        return result;
    }

}
